"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  _call: function(method, id, rule, invoiceType) {
    return ApiService.addErrorHandler($.ajax({
      url: this.endpoint(invoiceType, method, id),
      contentType: "application/json",
      type: "POST",
      data: JSON.stringify({ rule })
    }).then(
      DataStoreService.responseHandler,
      _.identity
    ));
  },
  endpoint: function(invoiceType, method, id) {
    if (invoiceType === "factor") {
      var type = "factor_invoices";
    } else if (invoiceType === "load_shipment") {
      var type = "load_shipments";
    } else {
      var type = "carrier_invoices";
    }
    ;
    return "/api/" + type + "/" + id + "/rules/" + method;
  },
  ignore: function(id, rule, invoiceType) {
    return this._call("ignore", id, rule, invoiceType);
  },
  enable: function(id, rule, invoiceType) {
    return this._call("enable", id, rule, invoiceType);
  }
};
